/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Payment_Validation_Upfront_TotalInputs */

const en_case_payment_validation_upfront_total = /** @type {(inputs: Case_Payment_Validation_Upfront_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For upfront payment, the upfront amount must equal the total amount.`)
};

const pt_br2_case_payment_validation_upfront_total = /** @type {(inputs: Case_Payment_Validation_Upfront_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No pagamento à vista, o valor à vista deve ser igual ao valor total.`)
};

/**
* | output |
* | --- |
* | "For upfront payment, the upfront amount must equal the total amount." |
*
* @param {Case_Payment_Validation_Upfront_TotalInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_payment_validation_upfront_total = /** @type {((inputs?: Case_Payment_Validation_Upfront_TotalInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Payment_Validation_Upfront_TotalInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_payment_validation_upfront_total(inputs)
	return pt_br2_case_payment_validation_upfront_total(inputs)
});